
/**
 * The Training Yard — Sparky Boi's unlock (MINIGAME_PROPOSALS O4). Benched
 * pets run timed obedience trials; each completion grants +1 drop-equivalent
 * pet level and some Scrap. A pity path so a maxed bench does not hang on
 * 0.4 percent drops alone.
 *
 * Interlock: time -> pet levels (existing system) + Scrap. Deliberately adds
 * NO new currency and NO new bonus type; it amplifies Pets, nothing else.
 */

export interface TrialDef {
  id: string;
  name: string;
  flavor: string;
  /** Yard level required. */
  tier: number;
  durationMs: number;
  /** The highest pet level this trial can train toward. */
  trainsTo: number;
  /** Scrap payout = waveScrap(highestWave) × this. */
  scrapMult: number;
}

export const TRIALS: TrialDef[] = [
  {
    id: 'trial.fetch',
    name: 'Fetch',
    flavor: 'The stick is a femur from a WAR-DEN. Do not ask.',
    tier: 1,
    durationMs: 10 * 60_000,
    trainsTo: 5,
    scrapMult: 25,
  },
  {
    id: 'trial.guard',
    name: 'Guard',
    flavor: 'Stand menacingly near the scrap pile. Growl at entropy.',
    tier: 2,
    durationMs: 45 * 60_000,
    trainsTo: 10,
    scrapMult: 90,
  },
  {
    id: 'trial.sitdown',
    name: 'Sit. DOWN.',
    flavor: 'Advanced obedience for advanced machines. Trains past what drops can teach.',
    tier: 3,
    durationMs: 150 * 60_000,
    trainsTo: 15,
    scrapMult: 280,
  },
  {
    id: 'trial.getem',
    name: "Get 'Em",
    flavor: 'The final discipline: pointed aggression on command. The fence learned to flinch.',
    tier: 4,
    durationMs: 8 * 60 * 60_000,
    trainsTo: 25,
    scrapMult: 800,
  },
];

export function getTrial(id: string): TrialDef | undefined {
  return TRIALS.find((t) => t.id === id);
}

/** Concurrent trials (the slots are kennels). */
export const YARD_SLOTS = 2;
export const MAX_YARD_LEVEL = 4;

/** Scrap cost factor to raise the yard (× waveScrap(highestWave), see sim/yard). */
export const YARD_UPGRADE_SCRAP_MULT = 350;
